export default class KliraCartItem {
    uid = null;
    quantity = 0;
    product = null;
    additionalFields = null;
    journeyMap = {
        201: {
            label: "OILY & HYPERPIGMENTED SKINSIZES",
            image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0002_Layer-Comp-3-scaled.jpg"
        },
        202: {
            label: "OILY & NON-HYPERPIGMENTED SKINSIZES",
            image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0003_Layer-Comp-4-scaled.jpg"
        },
        203: {
            label: "DRY & HYPERPIGMENTED SKINSIZES",
            image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0000_Layer-Comp-1.jpg"
        },
        204: {
            label: "DRY & NON-HYPERPIGMENTED SKINSIZES",
            image: "https://klira.skin/wp-content/uploads/2025/09/kliraskinecomm-6830_V1__0001_Layer-Comp-2-scaled.jpg"
        }
    };

    constructor(product, quantity, additionalFields) {
        this.uid = Math.random().toString(16).slice(2);
        // Product should be a KliraProduct (see products.js)
        this.product = product;
        this.quantity = quantity;
        this.additionalFields = additionalFields;
        if (product.isDayScript) {
            const journey_id = additionalFields.journey_id;

            this.additionalFields = {
                journey_id: journey_id || null,
                journey_label: journey_id ? this.journeyMap[journey_id]?.label || null : null,
                journey_image: journey_id ? this.journeyMap[journey_id]?.image || null : null,
            };
        } else {
            this.additionalFields = additionalFields;
        }
    }

    getQuantity() {
        return this.quantity;
    }

    getProduct() {
        return this.product;
    }

    getTotalPrice() {
        return this.getProduct().price * this.getQuantity();
    }

    getAdditionalFields() {
        return this.additionalFields;
    }
}